/* eslint-disable @typescript-eslint/naming-convention */
export const API_ROOT = '/api';
